import script from "./TripsBoardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TripsBoardPage.vue?vue&type=script&setup=true&lang=js"

import "./TripsBoardPage.vue?vue&type=style&index=0&id=dd0e29d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd0e29d2"]])

export default __exports__